import ReactComponentMounter from '../utils/react-component-mounter';

import Feed from '../apps/feed/Feed';
// 4/21/21 - MaharajAchievementCelebration is being used app/views/feed3p0/achievement_celebration/_base.haml
import MaharajAchievementCelebration from '../apps/feed/components/shared/MaharajAchievementCelebration';
import Activity from '../apps/feed/components/Activity';

ReactComponentMounter.register({
  Feed,
  MaharajAchievementCelebration,
  Activity
});
